import { jsx as _jsx } from "react/jsx-runtime";
import ErrorFilled16 from '@carbon/icons-react/es/error--filled/16';
import styled from 'styled-components';
const Wrapper = styled.div`
  color: var(--red-50);
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ErrorIcon = ()=>{
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsx(ErrorFilled16, {})
    });
};
